// Node Modules
import { RichText } from 'prismic-reactjs';

// Components
import Cards from '@/components/global-components/cards/Cards';
import Container from '@/components/global-components/Container';
import Banner from '@/components/global-components/banner/Banner';
import Highlights from '@/components/global-components/highlights/Highlights';
import Programs from '@/components/global-components/programs/Programs';
import SimpleBanner from '@/components/global-components/simple-banner/SimpleBanner';
import TopBanner from '@/components/global-components/top-banner/TopBanner';
import GroupTours from '../tours/group-tours/GroupTours';

// Queries
import { getPerfectLocationsContent } from '@/graphql/spanish-onsite-programs';

// Themes
import theme from '@/themes/index';

const SpanishOnsiteBody = ({
  content,
  isMobile,
  isTablet,
  isDesktop,
}) => {
  let style = {
    height: '25.75rem', padding: '8rem 1rem 4rem', 
  };
  let containerStyles = {
    width: '100%', maxWidth: '944px', height: 'auto', padding: '1rem 4rem', textAlign: 'center', 
  };
  if (isTablet) {
    style = {
      height: '19.75rem', paddingTop: '4.75rem', 
    };
  } else if (!isMobile) {
    style = {
      height: '25.75rem', paddingTop: '8.75rem', 
    };
  }
  
  content.bringAGroup.image = null;
  return (
    <>
      <section>
        <TopBanner {...content.topBanner} style={style} />
      </section>
      <section className="introduction-section">
        <Container>
          <RichText render={content.richText} />
        </Container>
      </section>
      <section className='highlights-section'>
        <Container>
          <Highlights
            content={content.programHighlights}
            isMobile={isMobile}
            isDesktop={isDesktop}
          />
        </Container>
      </section>
      <Banner content={content.banner} containerStyles={containerStyles}></Banner>
      <section className='programs-section'>
        <Container>
          <Programs
            alternatePosition={true}
            styleCardTitleStyle={{
              fontFamily: 's', color: '#00E065', 
            }}
            content={{
              programs: content.programs,
              programsTitle: content.programsTitle,
              programsSubtitle: content.programsSubtitle,
              programsIntro: content.programsIntro,
            }}
            showInformationCardTitle={true}
            isDesktop={isDesktop}
          />
        </Container>
      </section>
      
      <section className='other-options-section'>
        <Container>
          <Programs
            alternatePosition={false}
            styleCardTitleStyle={{
              fontFamily: 'MontserratBold', color: '#00E065', 
            }}
            content={{
              programs: content.otherPrograms,
              programsTitle: content.otherProgramsTitle,
              programsSubtitle: content.otherProgramsSubtitle,
            }}
            showInformationCardTitle={true}
            isDesktop={isDesktop}
          />
        </Container>
      </section>
      <Banner content={content.acommodationBanner} containerStyles={containerStyles}></Banner>
      <section style={{
        display: 'none',
      }} className="faq-banner-section">
        <SimpleBanner content={content.simpleBanner} />
      </section>
      <section className="perfect-locations">
        <Container>
          <Cards
            isMobile={isMobile}
            isDesktop={isDesktop}
            content={getPerfectLocationsContent(content)}
          />
        </Container>
      </section>
      <Banner content={content.banner1} containerStyles={containerStyles}></Banner>
      <section className='cpi-groups' id='cpi-groups'>
        <Container>
          <GroupTours 
            cpiGroups={content.bringAGroup} 
            whyCpiGroups={content.whyBringAGroup} 
            isDesktop={isDesktop} 
          />
        </Container>
      </section>
      
      
      <hr />
      <style jsx>{`
        hr {
          margin: 0 0.625rem;
        }

        section.highlights-section,
        section.programs-section,
        section.other-options-section,
        section.workshops-section,
        section.faq-banner-section,
        section.perfect-locations,
        section.introduction-section,
        section.cpi-groups {
          padding: 4rem 2rem;
        }

        section.perfect-locations {
          padding-bottom: 8rem;
        }

        section.introduction-section {
          text-align: center;
        }

        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          section.programs-section,
          section.other-options-section,
          section.workshops-section,
          section.perfect-locations,
          section.faq-banner-section,
          section.introduction-section,
          section.bring-group {
              padding: 3.75rem 2rem;
          }

          section.perfect-locations {
            padding-bottom: 10rem;
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          hr {
            margin: 0 15.375rem;
          }

          section.highlights-section,
          section.programs-section,
          section.other-options-section,
          section.workshops-section,
          section.perfect-locations,
          section.faq-banner-section,
          section.introduction-section,
          section.bring-group {
            padding: 3.75rem 2rem;
          }

          section.programs-section {
            padding-bottom: 10rem;
          }

          section.other-options-section {
            padding-top: 10rem;
          }

          section.perfect-locations {
            padding-bottom: 2rem;
          }

          section.introduction-section {
            text-align: justify;
          }
        }
      `}</style>
      <style global jsx>{`

        section.programs-section .programs-container .programs-container-header,
        section.other-options-section .programs-container .programs-container-header {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 5.25rem;
        }

        section.programs-section .programs-container .programs-container-header h6,
        section.other-options-section .programs-container .programs-container-header h6 {
          font-size: 1.25rem !important;
          line-height: 2.25rem;
        }

        section.other-options-section .programs-container .program-container .container .info-container .card-content h4 {
          font-family: ${theme.fontFamilies.montserratBold};
          font-size: 1.5rem;
        }

        section.perfect-locations div.cta-container  {
          gap: 1rem;
        }

        section.highlights-section .highlights-container h4 {
          color: ${theme.fontColors.optional5}
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.perfect-locations div.cta-container  {
            padding: 0;
          }
          section.programs-section .programs-container .programs-container-header h6,
          section.other-options-section .programs-container .programs-container-header h6 {
            max-width: 44.25rem;
            font-size: 1.5rem !important;
          }

          section.other-options-section .programs-container .program-container .container .info-container .card-content h4 {
            font-size: 2rem;
          }
        }
      `}</style>
    </>
  );
};

export default SpanishOnsiteBody;
